import CardButton from "@/components/card-button"
import { RiskFamily } from "@/entities/risk-family/model/risk-family.types"
import { getRiskFamilyImageUrl, RISK_FAMILY_IMAGE_STYLE } from "@/entities/risk-family/model/risk-family.utils"
import { faQuestion } from "@fortawesome/free-solid-svg-icons"

interface Props {
  family?: RiskFamily | null
  isRecommended?: boolean
  onClick?: () => void
}

export default function PhysicalRiskFamilyPanelButton({ family, isRecommended, onClick }: Props) {
  //Une famille peut exister sans image (famille « Non défini », ou code absent) : on garde alors le glyphe
  const imageUrl = family ? getRiskFamilyImageUrl(family) : null

  return (
    <div className="mb-20 w-full shrink-0">
      <div className="text-input-title flex">
        <span className="grey-t">Famille de risque</span>
      </div>
      {/* Wrapper flex : empeche la marge de 4px de fusionner avec celle du label, comme dans TextInput */}
      <div className="flex">
        <div className={`my-[4px] ${isRecommended ? "recommended-item-active" : ""}`}>
          <CardButton
            icon={imageUrl ? undefined : faQuestion}
            image={imageUrl}
            imageStyle={RISK_FAMILY_IMAGE_STYLE}
            isCta={!family}
            isImageAlwaysVisible
            isWithoutMargin
            onClick={onClick ?? (() => undefined)}
            title={family?.name ?? "Non défini"}
          />
        </div>
      </div>
    </div>
  )
}
